module.exports = __webpack_public_path__ + "img/knet-kwt.d11fe845.svg";